<template>
  <div class="message-reply__wrapper">
    <popper trigger="clickToOpen" ref="popover">
      <div class="popper message-reply__popover-wrapper">
        <in
          class="message-reply__popover-input"
          v-model="newTitle"
          :label="$t('view.flow.blockElements.reply.replyTitle')"
          maxlength="20"
        ></in>
        <sel
          class="message-reply__popover-input"
          v-model="newTarget"
          :label="$t('view.flow.blockElements.reply.buttonBlock')"
          @input="setVars"
        >
          <option value="raw">{{ $t('view.flow.blockElements.reply.rawPayload') }}</option>
          <option value="previous">{{ $t('view.flow.blockElements.reply.previousBlock') }}</option>
          <option :value="null">{{ $t('view.flow.blockElements.reply.noRedirect') }}</option>
          <optgroup v-for="group in $store.state.flowGroups" :key="group.id" :label="group.name">
            <option
              v-for="block in group.blocks"
              :key="block.id"
              :value="block.uuid"
            >{{ block.name }}</option>
          </optgroup>
        </sel>
        <in
          class="message-reply__popover-input"
          v-show="settings.saveToUserData"
          v-model="newValue"
          :label="$t('view.flow.blockElements.reply.replyValue')"
          maxlength="64"
        ></in>
        <in
          class="message-reply__popover-input"
          v-show="newTarget === 'raw'"
          v-model="newPayload"
          :label="$t('view.flow.blockElements.reply.payload')"
          maxlength="1000"
        ></in>

        <div class="message-reply__vars">
          <sw-button
            v-model="reply.data.passVariables"
            :label="$t('view.flow.blockElements.reply.redirectVariables')"
            v-if="blockVariables && Object.keys(blockVariables).length"
          ></sw-button>

          <div class="message-reply__vars-fields" v-if="reply.data.passVariables">
            <div v-for="(field, k, i) in blockVariables" :key="i" class="message-reply__vars-field">
              <in
                v-if="field.type === 'number' || field.type === 'string'"
                :label="k"
                v-model="reply.data.variables[k]"
              ></in>
              <sw-button v-else v-model="reply.data.variables[k]" :label="k"></sw-button>
            </div>
          </div>
        </div>

        <div class="message-reply__popover-buttons">
          <btn
            icon="trash"
            color="red"
            class="message-reply__popover-button"
            @click="$emit('delete')"
            small
          >{{ $t('btn.delete') }}</btn>
          <btn
            icon="save"
            class="message-reply__popover-button"
            @click="saveChanges"
            small
          >{{ $t('btn.save') }}</btn>
        </div>
      </div>

      <div slot="reference" class="message-reply">
        <div class="message-reply__content">
          <div class="message-reply__title">{{ reply.text[$store.state.flowEditorLocale] }}</div>
          <div class="message-reply__target" :class="labelClass">{{ labelContent }}</div>
        </div>
      </div>
    </popper>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    settings: Object
  },
  data() {
    return {
      reply: {},
      blocks: {},
      newTitle: '',
      newTarget: '',
      newValue: '',
      newPayload: ''
    }
  },
  methods: {
    saveChanges() {
      let o = {
        text: this.reply.text,
        data: this.reply.data
      }
      o.uuid = this.reply.uuid
      o.text[this.$store.state.flowEditorLocale] = this.newTitle
      o.data.target = this.newTarget
      o.data.value = this.newValue
      o.data.payload = this.newPayload
      if (o.data.target === '') o.data.target = null
      this.$set(this, 'reply', o)
      this.$emit('change', o)
      this.$refs.popover.doClose()
    },

    setVars() {
      this.reply.data.variables = {}
      for (let v in this.blockVariables) {
        let t = null
        if (v.type === 'string') t = ''
        else if (v.type === 'number') t = 0
        else if (v.type === 'boolean') t = true
        this.reply.data.variables[v] = t
      }
    }

  },
  created() {
    this.blocks = this.$store.getters.flowBlocks
    this.$set(this, 'reply', this.data)
    this.newTitle = this.reply.text[this.$store.state.flowEditorLocale]
    this.newTarget = this.reply.data.target
    this.newValue = this.reply.data.value
    this.newPayload = this.reply.data.payload

    setTimeout(() => {
      this.$forceUpdate()
    }, 0)
  },
  computed: {
    blockVariables: function () {
      const block = this.$store.getters.flowBlock(this.newTarget)
      if (!block) return null
      return block.data.variables
    },
    labelClass: function () {
      if (!this.reply.data.target) {
        return 'message-reply__target--no-redirect'
      } else if (this.reply.data.target === 'raw') {
        return 'message-reply__target--raw'
      } else if (this.reply.data.target === 'previous') {
        return 'message-reply__target--previous'
      }
    },
    labelContent: function () {
      if (this.blocks[this.reply.data.target]) {
        return this.blocks[this.reply.data.target].name
      } else if (this.reply.data.target === 'raw') {
        return this.reply.data.payload || '.'
      } else if (this.reply.data.target === 'previous') {
        return this.$t('view.flow.blockElements.reply.previous')
      } else {
        return this.$t('view.flow.blockElements.reply.noRedirect')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-reply {
  @include flowElementShadow();
  background-color: white;
  border-radius: 100px;
  padding: 2px 19px 4px 19px;
  cursor: pointer;
  margin-right: 9px;

  &__content {
    text-align: center;
  }

  &:hover {
    background-color: $messageHover;
  }

  &__text {
    max-width: 250px;
  }

  &__title {
    text-align: center;
  }

  &__reply {
    text-align: center;
  }

  &__target {
    color: white;
    background-color: $primary;
    text-align: center;
    font-size: 0.7em;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 5px;
    margin: 3px auto 0 auto;
    max-width: 250px;
    display: inline-block;

    &--no-redirect {
      background-color: $inactiveGrey;
    }

    &--raw {
      background-color: $purple;
    }

    &--previous {
      background-color: $blue;
    }
  }

  &__popover {
    margin-left: 4px;
  }

  &__popover-wrapper {
    width: 300px;
    padding: 5px 10px 10px 10px;
  }

  &__popover-input {
    margin-bottom: 12px;
  }

  &__popover-buttons {
    width: 80%;
    margin: 17px auto 0 auto;
    display: flex;
    justify-content: space-around;
  }

  &__vars {
    text-align: left;
  }

  &__vars-fields {
    @include alignedFlex(flex-start);
    flex-wrap: wrap;
    width: 100%;
  }

  &__vars-field {
    width: 45%;
    margin-right: 10px;
    margin-top: 5px;
  }
}
</style>
